import React from 'react';
import PropTypes from 'prop-types';
import DefaultError from '../../route/ErrorFallback';
export default class ErrorBoundary extends React.Component {
    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
        children: PropTypes.node.isRequired,
        Fallback: PropTypes.node,
        customerServiceUrl: PropTypes.string.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = { error: null, info: null };
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { error, info } = this.state;
        const { children, Fallback, customerServiceUrl } = this.props;
        if (error) {
            if (Fallback) {
                return <Fallback error={error} info={info}/>;
            }
            return <DefaultError error={error} customerServiceUrl={customerServiceUrl}/>;
        }
        return children;
    }
}
